/* eslint-disable camelcase, react-hooks/rules-of-hooks */
import { useMutation } from 'react-query';
import axios from '@utils/axios';

export function useGetIsEmailDisposable() {
  const mutationFn = async ({
    email
  }: {
    email: string;
  }): Promise<{ data: { disposable: boolean } }> => {
    return axios.get(`/api/check-valid-domain?email=${email}`);
  };

  return useMutation(mutationFn, {
    onError: () => {
      console.error('Something went wrong while fetching email validation');
    }
  });
}

export function useSuspendUser() {
  interface RequestData {
    userId: number;
    domain?: string;
    sendEmail?: boolean;
    shouldSuspend: boolean;
  }

  const mutationFn = async ({
    userId,
    domain,
    sendEmail,
    shouldSuspend
  }: RequestData): Promise<null> => {
    return axios.post(`/api/dashboard/suspend-user`, {
      userId,
      domain,
      sendEmail,
      shouldSuspend
    });
  };

  return useMutation(mutationFn, {
    onError: () => {
      console.error('error updating correction');
    }
  });
}
